import { render, staticRenderFns } from "./InfoParameter.vue?vue&type=template&id=130e6104&scoped=true&"
import script from "./InfoParameter.vue?vue&type=script&lang=js&"
export * from "./InfoParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e6104",
  null
  
)

export default component.exports